<template lang="pug">
f7-list(media-list class="student-list")
  students-query
    template(slot-scope="{ students }")
      ul
        student-list-item(
          v-for="student in students"
          :key="student.id"
          :student="student"
        )
</template>

<style lang="scss" scoped>
.student-list {
  margin: 0;
}
</style>

<script>
import StudentsQuery from '@/components/queries/StudentsQuery'
import StudentListItem from '@/components/molecules/StudentListItem'

export default {
  components: {
    StudentsQuery,
    StudentListItem,
  },
}
</script>
